// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Bazar";
export const CURRENCY_ISO = "CZK";
